var map = {
	"./chicken_fajitas.jpg": 422,
	"./cookd.svg": 227,
	"./doner_kebab.jpg": 423,
	"./icon/head_chef.svg": 424,
	"./logo.svg": 82,
	"./logo_shadowless.svg": 425,
	"./logo_simple.svg": 228,
	"./pasta_carbonara.jpg": 426,
	"./peach_chickpea_curry.jpg": 427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 421;